const updates = [
  { time: '10:42', tag: '爆料', title: '顶流男星深夜密会神秘女子，经纪人火速否认引热议', source: '微博热搜' },
  { time: '09:18', tag: '实锤', title: '某综艺节目录制现场爆发激烈冲突，导演组紧急叫停', source: '豆瓣八卦' },
  { time: '08:05', tag: '热议', title: '知名网红直播带货翻车，产品质检报告疑似造假遭曝光', source: '抖音快讯' },
  { time: '07:30', tag: '内幕', title: '娱乐圈某经纪公司高层变动，多位艺人合约面临解约', source: '独家消息' },
  { time: '昨日 23:15', tag: '吃瓜', title: '热播剧男女主戏外关系微妙，片场互动细节被深扒', source: '小红书' },
  { time: '昨日 21:40', tag: '争议', title: '某选秀节目投票数据异常，粉丝集体维权要求公开明细', source: '微博超话' },
  { time: '昨日 18:22', tag: '爆料', title: '知名导演新片选角内定传闻四起，投资方紧急回应', source: '行业消息' },
  { time: '昨日 16:08', tag: '追踪', title: '上月塌房网红复出试水，直播间人气暴跌引发群嘲', source: '综合报道' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
          <i className="ri-timer-flash-line text-primary-500 mr-2"></i>
          实时快讯
        </h2>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-300 -translate-x-1/2 hidden md:block"></div>

          <div className="space-y-6">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative flex flex-col md:flex-row gap-4 ${
                  i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className="flex-1 md:w-1/2 hidden md:block"></div>
                <div className="absolute left-4 md:left-1/2 top-5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 -translate-x-1/2 hidden md:block z-10"></div>
                <div className="flex-1 md:w-1/2 pl-8 md:pl-0">
                  <div
                    className={`bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 hover:border-primary-200 transition-colors ${
                      i % 2 === 0 ? 'md:mr-8' : 'md:ml-8'
                    }`}
                  >
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs font-medium text-foreground-500">{item.time}</span>
                      <span className={`px-2 py-0.5 text-[11px] font-semibold rounded-full whitespace-nowrap ${
                        item.tag === '实锤' ? 'bg-primary-100 text-primary-700' :
                        item.tag === '爆料' ? 'bg-accent-100 text-accent-700' :
                        'bg-secondary-100 text-secondary-700'
                      }`}>
                        {item.tag}
                      </span>
                      <span className="text-[11px] text-foreground-400 ml-auto whitespace-nowrap">{item.source}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-relaxed">
                      {item.title}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}